<template>
  <div class="supplier-fa">
    <div v-if="false">
      <div class="l-title">
        线上供应商号
      </div>
      <div class="l-supplier">
        <systemcs
          ref="systemcsRef"
          :systemcslist="supList"
          :scroll_height="scroll_height"
        ></systemcs>
      </div>
    </div>
    <div>
      <div class="l-title">
        线下供应商
      </div>
      <div v-loading="loading" class="r-supplier">
        <offlinecs
          :who="'supplier'"
          ref="offlinecsRef"
          :scroll_height="scroll_height - 40"
          :offlinelist="supofflinelist"
          :systemlist="supList"
        ></offlinecs>
      </div>
    </div>
    <div class="b-r" style="margin-left:10px">
      <div class="l-title">
        新建供应商
      </div>
      <div style="margin-top:10px">
        <el-form ref="form" :model="supplier_info" label-width="150px">
          <el-form-item
            v-for="(item, index) in supplier_form"
            :key="index"
            :label="item.label"
          >
            <el-input
              placeholder=""
              style="width:300px;"
              v-model="supplier_info[item.value]"
              :maxlength="item.value == 'region' ? 4 : 100"
              :show-word-limit="item.value == 'region' ? true : false"
            >
              <!-- <template slot="prepend">{{ item.label }}</template> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width:300px" @click="generateSup">
              保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { permissionMerchantList } from "@/api/merchant.js";

import {
  supplierlistbindingsupplier,
  offlineGenerateSup
} from "@/api/offlinestores.js";
import systemcs from "@/components/systemcs.vue";
import offlinecs from "../../components/offlinecs.vue";

export default {
  components: { systemcs, offlinecs },
  data() {
    return {
      supList: [],
      scroll_height: "",
      supofflinelist: [],
      loading: false,
      supplier_info: {
        supplier_no: "",
        supplier_name: "",
        region: "",
        mobile_no: "",
        address: "",
        contacts: "",
        telphone: ""
      },
      supplier_form: [
        { value: "supplier_no", label: "供应商号" },
        { value: "supplier_name", label: "供应商名称" },
        { value: "region", label: "区域名称" },
        { value: "mobile_no", label: "电话号码" },
        { value: "address", label: "地址" },
        { value: "contacts", label: "联系人" },
        { value: "telphone", label: "联系电话" }
      ]
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  methods: {
    async generateSup() {
      const res = await offlineGenerateSup(this.supplier_info);
      console.log("generateSup", res);
      if (this.testR(res)) {
        if (res.data.resp_data && res.data.resp_data.isSuccess) {
          console.log("成功1111111111111111111111111");
          this.successMessage(res.data.resp_data.msg);
          this.getSup(true);
        } else {
          this.successMessage(res.data.resp_data.msg);
        }
      }
    },
    async getSup(key) {
      this.loading = true;
      console.log("获取loading");
      this.supList = [];
      this.supofflinelist = [];
      const res = await permissionMerchantList();
      for (let i = 0; i < res.length; i++) {
        this.supList.push({
          label: res[i].merchant_id,
          value: res[i].mch_name
        });
      }
      const supres = await supplierlistbindingsupplier();
      for (let i = 0; i < supres.length; i++) {
        this.supofflinelist.push({
          label: supres[i].offline_supplier_no,
          value: supres[i].sup_name,
          inline: supres[i].supplier_no
        });
      }
      if (key) {
        this.$refs.offlinecsRef.setOfflineList(this.supofflinelist);
      }

      this.loading = false;
    }
  },
  mounted() {
    this.getSup();
  }
};
</script>
<style lang="less" scoped>
.b-r {
  width: 100%;
}
.l-title {
  height: 30px;
  font-size: 20px;
  line-height: 2;
  padding-left: 30px;
}

.supplier-fa {
  width: 100%;
  height: 100%;
  display: flex;
}
.l-supplier {
  width: 370px;
}
.r-supplier {
  width: 700px;
}
</style>
